import { Box, styled, Typography } from '@mui/material';

import { theme } from 'styles';

export const IconW = styled(Box)<{ iconbgcolor?: string }>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 12px;
  svg {
    width: 24px;
    height: 24px;
  }
  @media (max-width: 1023px) {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    svg {
      width: 32px;
      height: 32px;
    }
  }
`;

export const LabelW = styled(Typography)`
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  margin-top: 6px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const listItemStyles = {
  p: '7px 5px',
  borderRadius: '10px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '8px',
  color: `${theme.palette.primary.p080}`,
  opacity: '0.4',

  '.MuiTypography-root': {
    color: theme.palette.primary.p080,
  },

  '&.active': {
    opacity: '1',
    color: theme.palette.info.main,
    '.MuiAvatar-root': {
      border: `1px solid ${theme.palette.info.main}`,
    },
    '.MuiTypography-root': {
      color: theme.palette.info.main,
      fontWeight: 600,
    },
  },
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '0px',
    flex: '1',
    padding: '8px 4px',
    borderRadius: '0px',
  },
};
